import XLSX from 'xlsx';
import saveAs from '../utils/saveAs';

function generateArray(table) {
  const out = [];
  const rows = table.querySelectorAll('tr');

  const ranges = [];

  let previousCellValue;

  for (let R = 0; R < rows.length; ++R) {
    const outRow = [];
    const row = rows[R];
    const columns = [...row.querySelectorAll('th'), ...row.querySelectorAll('td')];

    for (let C = 0; C < columns.length; ++C) {
      const cell = columns[C];

      if (cell.getAttribute('class') === 'action') {
        continue;
      }

      let colspan = parseInt(cell.getAttribute('colspan'), 10);
      let rowspan = parseInt(cell.getAttribute('rowspan'), 10);

      const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

      let cellValue = isFirefox ? cell.textContent : cell.innerText;

      cellValue = cellValue.replace('V.', 'Vaulter');
      cellValue = cellValue.replace('H.', 'Horse');
      cellValue = cellValue.replace('L.', 'Lunger');

      if (R === 0 && cellValue === 'Vaulter') {
        cellValue = 'Vaulter First Name';
      }

      if (R === 0 && cellValue === '' && previousCellValue === 'Vaulter First Name') {
        cellValue = 'Vaulter Last Name';
      }

      if (cellValue !== '' && cellValue === +cellValue) {
        cellValue = +cellValue;
      }

      if (cellValue.includes('\n')) {
        cellValue = cellValue.replace(/\n/gi, '\r\n');
      }

      // Skip ranges
      ranges.forEach(range => {
        if (
          R >= range.s.r &&
          R <= range.e.r &&
          outRow.length >= range.s.c &&
          outRow.length <= range.e.c
        ) {
          for (let i = 0; i <= range.e.c - range.s.c; ++i) {
            outRow.push(null);
          }
        }
      });

      // Handle Row Span
      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;

        ranges.push({
          s: {
            r: R,
            c: outRow.length,
          },
          e: {
            r: R + rowspan - 1,
            c: outRow.length + colspan - 1,
          },
        });
      }

      // Handle Value
      outRow.push(cellValue !== '' ? cellValue : null);

      // Handle Colspan
      if (colspan) {
        for (let k = 0; k < colspan - 1; ++k) {
          outRow.push(null);
        }
      }

      previousCellValue = cellValue;
    }

    out.push(outRow);
  }

  return [out, ranges];
}

function datenum(v, date1904) {
  let vAltered = v;

  if (date1904) {
    vAltered += 1462;
  }

  const epoch = Date.parse(vAltered);

  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheetFromArrayOfArrays(data) {
  const ws = {};

  const range = {
    s: {
      c: 10000000,
      r: 10000000,
    },
    e: {
      c: 0,
      r: 0,
    },
  };

  for (let R = 0; R !== data.length; ++R) {
    for (let C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) {
        range.s.r = R;
      }

      if (range.s.c > C) {
        range.s.c = C;
      }

      if (range.e.r < R) {
        range.e.r = R;
      }

      if (range.e.c < C) {
        range.e.c = C;
      }

      const cell = {
        v: data[R][C],
      };

      if (cell.v === null) {
        cell.v = '';
      }

      const cellRef = XLSX.utils.encode_cell({
        c: C,
        r: R,
      });

      if (typeof cell.v === 'number') {
        cell.t = 'n';
      } else if (typeof cell.v === 'boolean') {
        cell.t = 'b';
      } else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = XLSX.SSF._table[14];
        cell.v = datenum(cell.v);
      } else {
        cell.t = 's';
      }

      if (R === 0) {
        cell.s = Object.assign({}, cell.s, {
          font: {
            bold: true,
          },
        });
      }

      if (R % 2) {
        cell.s = Object.assign({}, cell.s, {
          fill: {
            fgColor: {
              rgb: 'FFC5D9F1',
            },
          },
        });
      }

      ws[cellRef] = cell;
    }
  }

  if (range.s.c < 10000000) {
    ws['!ref'] = XLSX.utils.encode_range(range);
  }

  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) {
    return new Workbook();
  }

  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);

  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff;
  }

  return buf;
}

export default (tableElm, sheetName = 'Sheet 1', fileName = 'voltiz_export') => {
  const oo = generateArray(tableElm);
  const ranges = oo[1];

  /* original data */
  const data = oo[0];

  const wb = new Workbook();
  const ws = sheetFromArrayOfArrays(data);

  /* add ranges to worksheet */
  ws['!merges'] = ranges;

  /* add worksheet to workbook */
  wb.SheetNames.push(sheetName);
  wb.Sheets[sheetName] = ws;

  const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });

  saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
};



// WEBPACK FOOTER //
// ./src/utils/exportTableAsExcel.js